import { Component, Inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { OpenRouteCMRController } from '@shared/src/controllers/open/openroutecmr.controller';
import { SocketController } from '@shared/src/controllers/socket/socket.controller';
import { SystemController } from '@shared/src/controllers/system/system.controller';
import { DocumentParentObjectDto } from '@shared/src/dtos/documentaryreview/DocumentParentObjectDto';
import { OptionDto } from '@shared/src/dtos/maintenance/option/OptionDto';
import { OptionsStripDto } from '@shared/src/dtos/maintenance/option/OptionsStripDto';
import { RouteCMRBaseDto } from '@shared/src/dtos/route/cmr/RouteCMRBaseDto';
import { DocumentParentTypes } from '@shared/src/enums/DocumentParentTypes';
import { AlertService, HString } from '@shared/src/public-api';

@Component({
    selector: 'shared-external-ecmrs-digitaldocument',
    templateUrl: './shared.external.ecmrs.digitaldocument.component.html',
    styleUrls: ['./shared.external.ecmrs.digitaldocument.component.scss']
})
export class SharedExternalECMRsDigitalDocumentComponent implements OnInit {


    public useIonic: boolean = false;
    constructor(protected socketController: SocketController, public router: Router, protected activatedRoute: ActivatedRoute,
        @Inject('HomeController') protected homeController: HomeController,
        public openRouteCMRController: OpenRouteCMRController, public systemController: SystemController,
        @Inject('AlertService') public alertService: AlertService) {


        if (homeController.useIonic)
            this.useIonic = homeController.useIonic();
    }

    ngOnInit(): void {
        this.getDades();
    }

    public uuid: string = "";
    public getDades() {
        this.activatedRoute.params.subscribe(a => {
            this.uuid = a.uuidQR;
            this.loadRouteCMR();
        });
    }

    public __showSignature: boolean = true;
    @Input()
    public set showSignature(value: boolean) {
        if (this.__showSignature === value)
            return;
        this.__showSignature = value;
    }
    public get showSignature(): boolean {
        return this.__showSignature;
    }

    public value: RouteCMRBaseDto;
    loadRouteCMR() {
        if (!HString.isNullOrNullString(this.uuid)) {
            this.openRouteCMRController.getRouteCMRBaseByUUID(this.uuid).subscribe(data => { 
                this.wellcome(data);
            });
        }
    }

    public parentObject: DocumentParentObjectDto;
    public optionSelected: string = "";
    public onClickOption(option: OptionDto) {
        this.optionSelected = option ? option.optionId : "";
        if(this.optionSelected == "GENERAL")
            this.parentObject = this.value != null ? DocumentParentObjectDto.build(DocumentParentTypes.Route, this.value.routeId, 0, 0, 0, 0) : null;
        else if(this.getRoutePartCMRId() > 0)
            this.parentObject = this.value != null ? DocumentParentObjectDto.build(DocumentParentTypes.RoutePartCMR, 0, 0, 0, this.getRoutePartCMRId(), 0) : null;
    }

    public options: OptionsStripDto = new OptionsStripDto();
    public wellcome(value: RouteCMRBaseDto) {

        this.value = value;
        this.options = new OptionsStripDto();

        if(this.value != null && this.value.routePartCMRs != null && this.value.routePartCMRs.length > 0){
            if(this.value.routePartCMRs.length > 1){
               
                this.options.add(OptionDto.build("GENERAL", "General", "General", "", 1, -1, 1, true, false));
                let i = 2;
                this.value.routePartCMRs.forEach(x => {
                    if (x && x.routePartCMRId) {
                        this.options.add(OptionDto.build(x.routePartCMRId.toString(), this.formatCMRKey(x.routePartCMRKey), x.routePartCMRKey, "", i, -1, i > 3 ? -1 : 1, false, false));
                        i++;
                    }
                });
                this.onClickOption(this.options.getActualSelected());
            }else{
                this.optionSelected = this.getRoutePartCMRId() + "";
            }
        }else{
            this.optionSelected = "";
        }
    }

    getRoutePartCMRId(): number {
        if (this.value != null && this.value.routePartCMRs != null && this.value.routePartCMRs.length > 0){
            if(this.value.routePartCMRs.length > 1){
                if (HString.isNullOrNullString(this.optionSelected) || this.optionSelected == "0")
                    return 0;
                if (this.optionSelected == "GENERAL")
                    return 0;

                return this.getToNumber(this.optionSelected);
                
            }else{
                return this.value.routePartCMRs[0].routePartCMRId;
            }
        }
        return 0;
    }

    public getToNumber(input: string): number {
        return parseInt(input);
    }
    
    onDocumentValueChanged(){
        
    }

    public formatCMRKey(key: string): string {
        return key.replace(/0+/g, '..');
    }

    getOptionId(): number {
        if (!HString.isNullOrNullString(this.optionSelected)) {
            if (this.optionSelected == "GENERAL")
                return -1;
            return Number(this.optionSelected);
        }
        return 0;
    }

    public pretty(value: any): string {
        return JSON.stringify(value);
    }

}
